import { render, staticRenderFns } from "./MainButton.vue?vue&type=template&id=4ff80ef7&scoped=true"
import script from "./MainButton.vue?vue&type=script&lang=js"
export * from "./MainButton.vue?vue&type=script&lang=js"
import style0 from "./MainButton.vue?vue&type=style&index=0&id=4ff80ef7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff80ef7",
  null
  
)

export default component.exports